/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// English

export default {
	'Type something': 'Start writing...',
	pencil: 'Edit',
	Quadrate: 'Square'
};
